import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2dugn0n0pu: FaireBrandEntity = {
  token: "b_2dugn0n0pu",
  type: "brand",
  name: "Bewaltz",
  avatarUrl:
    "https://cdn.faire.com/fastly/a4edba8937259449442ed2798d5ead66fc25b315f90ace664ff700ccbf70a858.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/394b2fb2c9180ab1e3b2a2916559668a07e9032b52a9c3d2909d2abd687cc3cd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a4edba8937259449442ed2798d5ead66fc25b315f90ace664ff700ccbf70a858.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/394b2fb2c9180ab1e3b2a2916559668a07e9032b52a9c3d2909d2abd687cc3cd.jpeg",
  location: "Ontario, CA, USA",
  minimumOrderDollars: 99,
  rating: 4.9,
  reviewCount: 439,
  isTopShop: true,
  isInsider: true,
  description:
    "Bewaltz shares and creates lifestyle products in sunny Cali for you to enjoy and live in the moment! Our mission is simple - To provide the cutest, unique, and quality products to bring a smile to your face! :) Stay adventurous, laugh often and have fun! \nNEW! UNBEATABLE Deals for our BIGGEST Closeout Yet! Wallets, purses, mini plushies, drinkware, and more! :D✨\n\n✨RETURN POLICY: Product(s) must be unused and in original packaging within TWO WEEKS of delivery to be eligible for refunds and replacements.  \n✨MISSING/DAMAGED ITEMS REPORTING: Please report missing products and damages/defected items through Faire help center to process replacements; Please report missing straws, handbag straps, adaptors or other missing PARTS of an item directly with us via the messaging chat system :)\n\nEstablished 2017\n💖Everything Pink!💖\n👛Adorable Novelty Bags!👛\n🧸Bewaltz Exclusive Mini Plushies!🧸\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:03.266Z",
    importedBy: "entity-db-cli",
  },
};
